// extracted by mini-css-extract-plugin
export var bounce = "_m8-1";
export var generatingText = "_m8-6";
export var lightning = "_m8-4";
export var popup = "_m8-5";
export var progressBar = "_m8-7";
export var progressFill = "_m8-8";
export var progressShimmer = "_m8-9";
export var progressText = "_m8-a";
export var shimmer = "_m8-3";
export var uploadIcon = "_m8-0";
export var uploadingText = "_m8-2";